import { IState } from '@lib/store/reducer'
import { Tracking, TrackingEvent } from '@/lib/tracking'
import { getReferralParamData } from '@/utils/referralParams'

export const trackingSigninMethodSelected = (authMethod: string) => {
  Tracking.triggerEvent(TrackingEvent.SigninMethodSelected, {
    authMethod,
  })
}

export const trackingSigninCompleted = (authMethod: string) => {
  Tracking.triggerEvent(TrackingEvent.SigninCompleted, {
    authMethod,
  })
}

export const trackingReferralSignupSubmitted = async (state: IState) => {
  const { desktopUrl, refUsername } = await getReferralParamData(
    state.desktopUrl,
    state.refUsername
  )
  Tracking.triggerEvent(TrackingEvent.ReferralSignupSubmitted, {
    refUsername,
    desktopUrl,
  })
}
